import "./style.scss";
import CheckboxIcon from "../../assets/checkbox.icon.svg";
import CheckboxCheckedIcon from "../../assets/checkbox-checked.icon.svg";

export const ImageCheckbox = ({
    checked,
    onChange,
    icon = CheckboxIcon,
    checkedIcon = CheckboxCheckedIcon
}: {
    checked: boolean;
    onChange?: () => void;
    icon?: string;
    checkedIcon?: string;
}) => {
    return (
        <div className="image-checkbox">
            <div
                className="image-checkbox__icon"
                style={{ backgroundImage: checked ? `url(${checkedIcon})` : `url(${icon})` }}
                onClick={onChange}
            ></div>
        </div>
    );
};
